import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PusherService } from '../_service/pusher.service';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
@Component({
  selector: 'app-wallet-history',
  standalone: true,
  imports: [NgbModule, RouterModule, FormsModule, CommonModule],
  templateUrl: './wallet-history.component.html',
  styleUrl: './wallet-history.component.scss'
})
export class WalletHistoryComponent {
  minutes = 0
  private modalService = inject(NgbModal);
  buzzNotification: any = null;
  constructor(
    private pusherService: PusherService,
    private location: Location
  ) { }
  ngOnInit(): void {
    // this.pusherService.channel.bind('waiter-notification-all', (data: any) => {
    //   if (data.notification_type == "buzz") {
    //     this.playBeep();
    //     this.buzzNotification = data;
    //   }
    // })
    // this.pusherService.channel.bind('waiter-notification-15', (data: any) => {
    //   if (data.notification_type == "buzz") {
    //     this.playBeep();
    //     this.buzzNotification = data;
    //   }
    // })
  }
  playBeep() {
    const audio = new Audio('beep.mp3'); // Replace with the correct path to your audio file
    audio.load(); // Load the audio file before playing it
    audio.play().catch(error => {
      console.error("Error playing audio", error); // Catch errors if any
    });
  }

  goBack() {
    this.location.back();  // Navigate back to the previous route
  }
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' }).result
  }
  settime(content2: any) {
    this.modalService.dismissAll()
    this.modalService.open(content2, { centered: true, size: 'md' }).result
  }
  minus() {
    if (this.minutes >= 0.1) {
      this.minutes--
    }
  }
  plus() {
    this.minutes++
  }
  update() { }

}
